import "./Home.module.css";
import CabeceraDeMarca from "@/reusable_sections/Header";
import ConectaConTuEnergia from "./sections/ConectaConTuEnergia";
import ColeccionesDeIntencion from "./sections/ColeccionesDeIntencion";
import AmuletosDestacados from "./sections/AmuletosDestacados";
import ElPoderDeLasPiedras from "./sections/ElPoderDeLasPiedras";
import UneteALaMagia from "./sections/UneteALaMagia";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CabeceraDeMarca />
      <ConectaConTuEnergia />
      <ColeccionesDeIntencion />
      <AmuletosDestacados />
      <ElPoderDeLasPiedras />
      <UneteALaMagia />
      <Footer />
    </div>;
}